<template>
  <el-select
    ref="select"
    v-model="value"
    :placeholder="label"
    @update:modelValue="update"
  >
    <el-option key="all" label="All protocols" :value="null">
      All protocols
    </el-option>
    <el-option
      v-for="protocol in ProtocolTypeFilterLabels"
      :key="protocol.type_id"
      :label="protocol.label"
      :value="protocol.type_id"
    >
      {{ protocol.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { ProtocolTypeFilterLabels } from '@/api/types'

export default defineComponent({
  name: 'ProtocolSelect',
  props: {
    label: {
      type: String,
      default: 'Protocol type'
    },
    modelValue: {
      type: Number,
      default: null
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, ProtocolTypeFilterLabels, value }
  }
})
</script>
